module.exports = __webpack_public_path__ + "seller/img/lianjie.681819e5.png";